import { Component, Prop, Element, Listen, Event, EventEmitter, h } from '@stencil/core';

/**
 * @deprecated This component will be removed in v8. Please use the `pn-progress-stepper` instead.
 * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-feedback-progress-stepper--docs Use `pn-progress-stepper` instead.}
 */
@Component({
  tag: 'pn-progress-indicator',
  styleUrl: 'pn-progress-indicator.scss',
})
export class PnProgressIndicator {
  @Element() hostElement: HTMLElement;

  /** Takes the index of the active step */
  @Prop({ mutable: true }) activeStep: number = 0;

  /** This will emit when progress is changed and is the value you want to bind to your VM state */
  @Event() progresschange: EventEmitter<number>;

  @Listen('setactivestep')
  setActiveStepHandler({ detail }) {
    this.activeStep = detail;
    this.progresschange.emit(this.activeStep);
  }

  componentWillLoad() {
    this.passPropsToChildren();
  }

  componentDidUpdate() {
    this.passPropsToChildren();
  }

  passPropsToChildren() {
    const children = Array.from(
      this.hostElement.querySelectorAll<HTMLPnProgressIndicatorStepElement>('pn-progress-indicator-step'),
    );

    children.forEach((child, i) => {
      child.activeStep = this.activeStep;
      child.index = i;
    });
  }

  render() {
    return (
      <div class="pn-progress-indicator">
        <slot />
      </div>
    );
  }
}
